export default "__VITE_ASSET__CvUNHhxk__"